// Windows-1252 (CP1252/ANSI) to Unicode mapping table
// Windows-1252 is a superset of ISO-8859-1 with additional characters in the 0x80-0x9F range
// This table maps each Windows-1252 byte value (0-255) to its corresponding Unicode code point
/* eslint-disable max-len */
// prettier-ignore
const WINDOWS_1252_TO_UNICODE = [
  // 0x00-0x1F: Control characters - same as ASCII
  0x0000, 0x0001, 0x0002, 0x0003, 0x0004, 0x0005, 0x0006, 0x0007, // NUL-BEL
  0x0008, 0x0009, 0x000a, 0x000b, 0x000c, 0x000d, 0x000e, 0x000f, // BS-SI
  0x0010, 0x0011, 0x0012, 0x0013, 0x0014, 0x0015, 0x0016, 0x0017, // DLE-ETB
  0x0018, 0x0019, 0x001a, 0x001b, 0x001c, 0x001d, 0x001e, 0x001f, // CAN-US

  // 0x20-0x7F: Standard ASCII printable characters
  0x0020, 0x0021, 0x0022, 0x0023, 0x0024, 0x0025, 0x0026, 0x0027, // !"#$%&'
  0x0028, 0x0029, 0x002a, 0x002b, 0x002c, 0x002d, 0x002e, 0x002f, // ()*+,-./
  0x0030, 0x0031, 0x0032, 0x0033, 0x0034, 0x0035, 0x0036, 0x0037, // 01234567
  0x0038, 0x0039, 0x003a, 0x003b, 0x003c, 0x003d, 0x003e, 0x003f, // 89:;<=>?
  0x0040, 0x0041, 0x0042, 0x0043, 0x0044, 0x0045, 0x0046, 0x0047, // @ABCDEFG
  0x0048, 0x0049, 0x004a, 0x004b, 0x004c, 0x004d, 0x004e, 0x004f, // HIJKLMNO
  0x0050, 0x0051, 0x0052, 0x0053, 0x0054, 0x0055, 0x0056, 0x0057, // PQRSTUVW
  0x0058, 0x0059, 0x005a, 0x005b, 0x005c, 0x005d, 0x005e, 0x005f, // XYZ[\]^_
  0x0060, 0x0061, 0x0062, 0x0063, 0x0064, 0x0065, 0x0066, 0x0067, // `abcdefg
  0x0068, 0x0069, 0x006a, 0x006b, 0x006c, 0x006d, 0x006e, 0x006f, // hijklmno
  0x0070, 0x0071, 0x0072, 0x0073, 0x0074, 0x0075, 0x0076, 0x0077, // pqrstuvw
  0x0078, 0x0079, 0x007a, 0x007b, 0x007c, 0x007d, 0x007e, 0x007f, // xyz{|}~DEL

  // 0x80-0xFF: Extended characters - Windows-1252 specific mappings
  0x20ac, 0x0081, 0x201a, 0x0192, 0x201e, 0x2026, 0x2020, 0x2021, // €,‚,ƒ,„,…,†,‡
  0x02c6, 0x2030, 0x0160, 0x2039, 0x0152, 0x008d, 0x017d, 0x008f, // ˆ,‰,Š,‹,Œ,,Ž,
  0x0090, 0x2018, 0x2019, 0x201c, 0x201d, 0x2022, 0x2013, 0x2014, // ,'‚',"," •,–,—
  0x02dc, 0x2122, 0x0161, 0x203a, 0x0153, 0x009d, 0x017e, 0x0178, // ˜,™,š,›,œ,,ž,Ÿ
  0x00a0, 0x00a1, 0x00a2, 0x00a3, 0x00a4, 0x00a5, 0x00a6, 0x00a7, // NBSP,¡,¢,£,¤,¥,¦,§
  0x00a8, 0x00a9, 0x00aa, 0x00ab, 0x00ac, 0x00ad, 0x00ae, 0x00af, // ¨,©,ª,«,¬,­,®,¯
  0x00b0, 0x00b1, 0x00b2, 0x00b3, 0x00b4, 0x00b5, 0x00b6, 0x00b7, // °,±,²,³,´,µ,¶,·
  0x00b8, 0x00b9, 0x00ba, 0x00bb, 0x00bc, 0x00bd, 0x00be, 0x00bf, // ¸,¹,º,»,¼,½,¾,¿
  0x00c0, 0x00c1, 0x00c2, 0x00c3, 0x00c4, 0x00c5, 0x00c6, 0x00c7, // À,Á,Â,Ã,Ä,Å,Æ,Ç
  0x00c8, 0x00c9, 0x00ca, 0x00cb, 0x00cc, 0x00cd, 0x00ce, 0x00cf, // È,É,Ê,Ë,Ì,Í,Î,Ï
  0x00d0, 0x00d1, 0x00d2, 0x00d3, 0x00d4, 0x00d5, 0x00d6, 0x00d7, // Ð,Ñ,Ò,Ó,Ô,Õ,Ö,×
  0x00d8, 0x00d9, 0x00da, 0x00db, 0x00dc, 0x00dd, 0x00de, 0x00df, // Ø,Ù,Ú,Û,Ü,Ý,Þ,ß
  0x00e0, 0x00e1, 0x00e2, 0x00e3, 0x00e4, 0x00e5, 0x00e6, 0x00e7, // à,á,â,ã,ä,å,æ,ç
  0x00e8, 0x00e9, 0x00ea, 0x00eb, 0x00ec, 0x00ed, 0x00ee, 0x00ef, // è,é,ê,ë,ì,í,î,ï
  0x00f0, 0x00f1, 0x00f2, 0x00f3, 0x00f4, 0x00f5, 0x00f6, 0x00f7, // ð,ñ,ò,ó,ô,õ,ö,÷
  0x00f8, 0x00f9, 0x00fa, 0x00fb, 0x00fc, 0x00fd, 0x00fe, 0x00ff, // ø,ù,ú,û,ü,ý,þ,ÿ
]
/* eslint-enable max-len */

// Decodes a base64 encoded string into a Uint8Array of bytes
// Used to convert base64 receipt data from the server into raw bytes
export const decodeBase64 = (b64) =>
  Uint8Array.from(atob(b64), (c) => c.charCodeAt(0))

// Converts Windows-1252 encoded bytes to a Unicode string
// Star printers now use Windows-1252 encoding, which includes the Euro symbol
// and other accented letters commonly used in Western European languages
export const decodeWindows1252 = (bytes) => {
  return Array.from(bytes, (byte) =>
    String.fromCharCode(WINDOWS_1252_TO_UNICODE[byte])
  ).join("")
}
